import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MessageSquare } from "lucide-react";

export default function CommentsCard() {
  const [comments, setComments] = useState([]);

  useEffect(() => {
    api.get("/admin/comments").then((r) => setComments(r.data || []));
  }, []);

  return (
    <div className="tac-card p-7 mt-8" data-testid="admin-comments-card">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="overline flex items-center gap-2">
            <MessageSquare size={12} /> Mailbag
          </div>
          <h2 className="font-display text-3xl uppercase mt-2">Comments &amp; suggestions</h2>
        </div>
        <div className="font-mono-tactical text-xs text-white/50 uppercase tracking-[0.25em]">
          {comments.length} entries
        </div>
      </div>
      <div className="mt-6 max-h-[480px] overflow-y-auto divide-y divide-white/5">
        {comments.length === 0 && (
          <div className="py-8 text-white/60 text-sm">No messages yet.</div>
        )}
        {comments.map((c) => (
          <div key={c.id} className="py-4 grid md:grid-cols-12 gap-3" data-testid={`comment-${c.id}`}>
            <div className="md:col-span-3">
              <div className="font-semibold">{c.name}</div>
              {c.email && (
                <a href={`mailto:${c.email}`} className="text-[10px] text-[#FF1493] hover:underline font-mono-tactical">
                  {c.email}
                </a>
              )}
              {c.city && <div className="text-[10px] text-white/50 mt-1">{c.city}</div>}
            </div>
            <div className="md:col-span-2">
              <span className="bg-[#0A0A0A] border border-[#FF1493]/40 text-[#FF1493] px-2 py-1 text-[10px] tracking-[0.2em] uppercase font-display">
                {c.kind}
              </span>
              <div className="text-[10px] font-mono-tactical text-white/40 mt-2 uppercase tracking-[0.2em]">
                {new Date(c.created_at).toLocaleDateString()}
              </div>
            </div>
            <div className="md:col-span-7 text-sm text-white/80 whitespace-pre-wrap">{c.message}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
